export default __webpack_public_path__ + "static/media/featSportDesktop.1b47d578.png";